/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum CohortrendementVanafWaarde {
    ZONDER_VERTRAGING = "Zonder vertraging",
    OPGESTROOMD = "Opgestroomd",
    AFGESTROOMD = "Afgestroomd",
    AFGESTROOMD_GEDOUBLEERD = "Afgestroomd & gedoubleerd",
    GEDOUBLEERD = "Gedoubleerd",
    OPGESTROOMD_GEDOUBLEERD = "Opgestroomd & gedoubleerd"
}
